export const DISCOVER = 'discover';
export const SEARCH = 'search';
export type PerspectiveType = typeof DISCOVER | typeof SEARCH;
